<template>
  <div class="deposit-tabs">
    <button
      v-if="showNavigationArrows"
      class="deposit-tabs__arrow deposit-tabs__arrow--left"
      @click="scrollLeft"
      :disabled="!canScrollLeft"
      aria-label="Scroll left"
    ></button>
    <div ref="tabsList" class="deposit-tabs__nav-container">
      <tabs :items="items" :theme="theme" :active-tab="activeTab" @tabChange="onTabChange"></tabs>
    </div>
    <button
      v-if="showNavigationArrows"
      class="deposit-tabs__arrow deposit-tabs__arrow--right"
      @click="scrollRight"
      :disabled="!canScrollRight"
      aria-label="Scroll right"
    ></button>
  </div>
</template>

<script src="./deposit-tabs.js"></script>
<style src="./deposit-tabs.scss" lang="scss"></style>
